import React from 'react';

export default class CardSection extends React.Component {

    render() {
        const { children } = this.props;

        return (
            <div className="header">
                <div className="row">
                    {children}
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/CardSection.jsx